module.exports = __webpack_public_path__ + "static/media/terminal.8308aa94.svg";